import { useCapabilities } from '@crm/hooks/useCapabilities'
import { TableActions } from '@shared/components'
import { MenuProps } from 'antd'

type Props = {
  options?: MenuProps['items']
}

/**
 * Row actions of a global catalog. Every one of them writes to the catalog, so
 * roles that may only read it get an empty menu — which TableActions renders
 * as nothing, leaving the cell blank.
 */
export const CatalogActions = ({ options }: Props) => {
  const { canManageCatalogs } = useCapabilities()

  return <TableActions options={canManageCatalogs ? options : []} />
}
